module.exports = __webpack_public_path__ + "assets/img/0.0_dy_xq_red@2x.1908444a.png";